import { render } from "./UltraAccordion.vue?vue&type=template&id=010563c8&scoped=true"
import script from "./UltraAccordion.vue?vue&type=script&lang=js"
export * from "./UltraAccordion.vue?vue&type=script&lang=js"

import "./UltraAccordion.vue?vue&type=style&index=0&id=010563c8&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010563c8"]])

export default __exports__